// extracted by mini-css-extract-plugin
export default {"closeBtn":"inspectMessage_closeBtn__tj2mW","save":"inspectMessage_save__S6OOW","close":"inspectMessage_close__62Y63"};